import { StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import moment from 'moment'
import GeneratePDF from '../../../common/GeneratePDF'
import { useTheme } from '@mui/material'
import { getStaOperatorHamaliLabel, isStaCompany } from '../../../common/helper'
//Summary table LargePDF
export const WithVehicleAndChartDateSummaryLargePdf = ({ fromDate, toDate, tableData, headerData, detailedFilter }) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const styles = StyleSheet.create({
    dataRow: {
      flexDirection: 'row',
      borderBottom: '1pt solid #A6A8AB',
    },
    dataCell: {
      flex: 1,
      fontSize: '12px',
      fontWeight: 500,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    headerCell: {
      backgroundColor: '#BFE1FF',
      flex: 1,
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    subHeadingRow: {
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    dataSubRow: {
      textAlign: 'right',
      borderBottom: '1pt solid #A6A8AB',
      backgroundColor: '#f1f9ff',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  })
  return (
    <GeneratePDF
      width={'100%'}
      height={'440px'}
      size={[1670, 2000]}
      reportName={'Dispatch Report'}
      generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
      reportView={`Report View: ${detailedFilter?.Name}`}
      isSubHeading={true}
      title={'Dispatch Report'}
    >
      <View style={{ border: '1pt solid #A6A8AB' }}>
        <View style={styles.dataRow}>
          <Text style={styles.headerCell}>From Dispatch Date</Text>
          <Text style={styles.headerCell}>To Dispatch Date</Text>
          <Text style={styles.headerCell}>dispatch By Branch</Text>
          <Text style={styles.headerCell}>Destination City</Text>
          <Text style={styles.headerCell}>DestinationBranch</Text>
          <Text style={styles.headerCell}>Vehicle Number</Text>
          <Text style={styles.headerCell}>Payment Type</Text>
          <Text style={styles.headerCell}>Report Type</Text>
          <Text style={styles.headerCell}>Report View</Text>
          <Text style={styles.headerCell}>Report Option</Text>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
          <Text style={styles.dataCell}>{headerData?.toDate}</Text>
          <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
          <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
          <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
          <Text style={styles.dataCell}>{headerData?.reportType}</Text>
          <Text style={styles.dataCell}>{headerData?.reportView}</Text>
          <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
        </View>
      </View>
      <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
        <View style={styles.dataRow}>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Vehicle No</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Trip Name</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Trip ID</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Charte Date</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>NOP</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay + COD Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>OnAccount Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>DDDV Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Selft Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Other Charges</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Valuation</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>GST</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Net Amount</Text>
        </View>
        <View style={{ border: '1pt solid #A6A8AB' }}>
          {tableData?.length < 1 ? (
            <>
              <View style={styles.dataRow}>
                <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                  No results found. Please refine your search parameters and search again.
                </Text>
              </View>
            </>
          ) : (
            <>
              {tableData?.map((item, index) => {
                return (
                  <>
                    <View style={styles.dataSubRow}>
                      {Object.keys(item).length == 15 ? (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '360px',
                              textAlign: 'right',
                            }}
                          >
                            {item.ChartDate}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.Quantity}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.paidFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.ToPayCodFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnAccountFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.DddvFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.FocFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.SelfFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.totalFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.SummaryAllCartage}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.SummaryAllHamali}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.SummaryAllOther}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.SummaryInsurance}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.SummaryServiceTaxAmount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.SummaryNetAmount}
                          </Text>
                        </>
                      ) : (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.VehicleNo}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.TripName}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.TripID}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.ChartDate}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.Quantity}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.paidFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.ToPayCodFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.OnAccountFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.DddvFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.FocFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.SelfFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.totalFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.SummaryAllCartage}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.SummaryAllHamali}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.SummaryAllOther}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.SummaryInsurance}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.SummaryServiceTaxAmount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                              backgroundColor: 'white',
                            }}
                          >
                            {item.SummaryNetAmount}
                          </Text>
                        </>
                      )}
                    </View>
                  </>
                )
              })}
            </>
          )}
        </View>
      </View>
    </GeneratePDF>
  )
}
export const WithHamaliAndChartageSummaryLargePdf = ({ fromDate, toDate, tableData, headerData, detailedFilter }) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const styles = StyleSheet.create({
    dataRow: {
      flexDirection: 'row',
      borderBottom: '1pt solid #A6A8AB',
    },
    dataCell: {
      flex: 1,
      fontSize: '12px',
      fontWeight: 500,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    headerCell: {
      backgroundColor: '#BFE1FF',
      flex: 1,
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    subHeadingRow: {
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    dataSubRow: {
      textAlign: 'right',
      borderBottom: '1pt solid #A6A8AB',
      backgroundColor: '#f1f9ff',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  })
  return (
    <GeneratePDF
      width={'100%'}
      height={'440px'}
      size={[1670, 2000]}
      reportName={'Dispatch Report'}
      generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
      reportView={`Report View: ${detailedFilter?.Name}`}
      isSubHeading={true}
      title={'Dispatch Report'}
    >
      <View style={{ border: '1pt solid #A6A8AB' }}>
        <View style={styles.dataRow}>
          <Text style={styles.headerCell}>From Dispatch Date</Text>
          <Text style={styles.headerCell}>To Dispatch Date</Text>
          <Text style={styles.headerCell}>dispatch By Branch</Text>
          <Text style={styles.headerCell}>Destination City</Text>
          <Text style={styles.headerCell}>DestinationBranch</Text>
          <Text style={styles.headerCell}>Vehicle Number</Text>
          <Text style={styles.headerCell}>Payment Type</Text>
          <Text style={styles.headerCell}>Report Type</Text>
          <Text style={styles.headerCell}>Report View</Text>
          <Text style={styles.headerCell}>Report Option</Text>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
          <Text style={styles.dataCell}>{headerData?.toDate}</Text>
          <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
          <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
          <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
          <Text style={styles.dataCell}>{headerData?.reportType}</Text>
          <Text style={styles.dataCell}>{headerData?.reportView}</Text>
          <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
        </View>
      </View>
      <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
        <View style={styles.dataRow}>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>SN</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Vehicle No</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Driver Name & Contact</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatch To City</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>NOP(Units)</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total LRs</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay + COD Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>OnAccount Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC+Self Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>DDDV Freight</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>GST</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Valuation</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Other Charges</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Amount</Text>
        </View>
        <View style={{ border: '1pt solid #A6A8AB' }}>
          {tableData?.length < 1 ? (
            <>
              <View style={styles.dataRow}>
                <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                  No results found. Please refine your search parameters and search again.
                </Text>
              </View>
            </>
          ) : (
            <>
              {tableData?.map((item, index) => {
                return (
                  <>
                    <View style={styles.dataSubRow}>
                      {Object.keys(item).length == 15 ? (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '360px',
                              textAlign: 'right',
                            }}
                          >
                            {item.Station}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalUnits}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalLRCount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnAccountFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.FocAndSelfFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.HamaliTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.CartageTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.GstTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.ValuationTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OtherChargeTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalNetAmount}
                          </Text>
                        </>
                      ) : (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'left',
                            }}
                          >
                            {index + 1}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'left',
                            }}
                          >
                            {item.BusNumber}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'left',
                            }}
                          >
                            {item.DriverConductorContactNo}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'left',
                            }}
                          >
                            {item.Station}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalUnits}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalLRCount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnAccountFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.FocAndSelfFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.HamaliTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.CartageTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.GstTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.ValuationTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.OtherChargeTotal}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalNetAmount}
                          </Text>
                        </>
                      )}
                    </View>
                  </>
                )
              })}
            </>
          )}
        </View>
      </View>
    </GeneratePDF>
  )
}
export const WithOtherChargeSummaryLargePdf = ({ fromDate, toDate, tableData, headerData, detailedFilter }) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const styles = StyleSheet.create({
    dataRow: {
      flexDirection: 'row',
      borderBottom: '1pt solid #A6A8AB',
    },
    dataCell: {
      flex: 1,
      fontSize: '12px',
      fontWeight: 500,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    headerCell: {
      backgroundColor: '#BFE1FF',
      flex: 1,
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    subHeadingRow: {
      fontSize: '12px',
      fontWeight: 600,
      paddingVertical: 8,
      paddingHorizontal: 5,
      color: '#444',
    },
    dataSubRow: {
      textAlign: 'right',
      borderBottom: '1pt solid #A6A8AB',
      backgroundColor: '#f1f9ff',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  })
  return (
    <GeneratePDF
      width={'100%'}
      height={'440px'}
      size={[2300, 2500]}
      reportName={'Dispatch Report'}
      generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
      reportView={`Report View: ${detailedFilter?.Name}`}
      isSubHeading={true}
      title={'Dispatch Report'}
    >
      <View style={{ border: '1pt solid #A6A8AB' }}>
        <View style={styles.dataRow}>
          <Text style={styles.headerCell}>From Dispatch Date</Text>
          <Text style={styles.headerCell}>To Dispatch Date</Text>
          <Text style={styles.headerCell}>dispatch By Branch</Text>
          <Text style={styles.headerCell}>Destination City</Text>
          <Text style={styles.headerCell}>DestinationBranch</Text>
          <Text style={styles.headerCell}>Vehicle Number</Text>
          <Text style={styles.headerCell}>Payment Type</Text>
          <Text style={styles.headerCell}>Report Type</Text>
          <Text style={styles.headerCell}>Report View</Text>
          <Text style={styles.headerCell}>Report Option</Text>
        </View>
        <View style={{ flexDirection: 'row' }}>
          <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
          <Text style={styles.dataCell}>{headerData?.toDate}</Text>
          <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
          <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
          <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
          <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
          <Text style={styles.dataCell}>{headerData?.reportType}</Text>
          <Text style={styles.dataCell}>{headerData?.reportView}</Text>
          <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
        </View>
      </View>
      <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
        <View style={styles.dataRow}>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>
            Vehicle No <br />
            Seal No{' '}
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>
            Drvr Name <br />
            Drvr No
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>
            Disp. City
            <br />
            Disp. Br.
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>
            ToPay + <br />
            COD Units
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid Units</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            On- <br />
            Act Units
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            FOC+ <br />
            Self Units
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>DDDV Units</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>NET Units</Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            ToPay+ <br />
            COD Frt
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            Paid
            <br />
            Frt
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            On-Act <br />
            Frt
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            FOC+ <br />
            COD Frt
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            DDDV <br />
            Frt
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            NET <br />
            Frt
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            ToPay+COD <br /> GST+OTH
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            Paid <br />
            GST+OTH
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            On-Act <br /> GST+OTH
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            FOC+Self <br /> GST+OTH
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            DDDV <br /> GST+OTH
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            NET <br /> GST+OTH
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            Val. <br />
            Charge
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            Oth <br />
            Charge
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            NET <br /> LR
          </Text>
          <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>
            NET <br />
            Amt.
          </Text>
        </View>
        <View style={{ border: '1pt solid #A6A8AB' }}>
          {tableData?.length < 1 ? (
            <>
              <View style={styles.dataRow}>
                <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                  No results found. Please refine your search parameters and search again.
                </Text>
              </View>
            </>
          ) : (
            <>
              {tableData?.map((item, index) => {
                return (
                  <>
                    <View style={styles.dataSubRow}>
                      {Object.keys(item).length == 23 ? (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '270px',
                              textAlign: 'right',
                            }}
                          >
                            {item.Station} <br />
                            {item.ToBranchName}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnAccountUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.FocAndSelfUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalUnits}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnAccountFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.FocAndSelfFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayCodGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnActGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.FOCSelfGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.NetOther}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.Insurance}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.OtherCharge}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalLRCount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalNetAmount}
                          </Text>
                        </>
                      ) : (
                        <>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'left',
                            }}
                          >
                            {item.BusNumber} {item.SealNo}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'left',
                            }}
                          >
                            {item.DriverConductorName} {item.ContactNo}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'left',
                            }}
                          >
                            {item.Station} {item.ToBranchName}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnAccountUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.FocAndSelfUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVUnit}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalUnits}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnAccountFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.FocAndSelfFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalFreight}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TopayCodGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.PaidGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.OnActGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.FOCSelfGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.DDDVGstOth}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.NetOther}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.Insurance}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.OtherCharge}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalLRCount}
                          </Text>
                          <Text
                            style={{
                              ...styles.dataCell,

                              backgroundColor: tableHeaderColor?.isTotalColor,
                              minWidth: '90px',
                              backgroundColor: 'white',
                              textAlign: 'right',
                            }}
                          >
                            {item.TotalNetAmount}
                          </Text>
                        </>
                      )}
                    </View>
                  </>
                )
              })}
            </>
          )}
        </View>
      </View>
    </GeneratePDF>
  )
}
export const BranchSummaryLargePdf = ({ fromDate, toDate, tableData, headerData, detailedFilter }) => {
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const styles = StyleSheet.create({
      dataRow: {
        flexDirection: 'row',
        borderBottom: '1pt solid #A6A8AB',
      },
      dataCell: {
        flex: 1,
        fontSize: '12px',
        fontWeight: 500,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      headerCell: {
        backgroundColor: '#BFE1FF',
        flex: 1,
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      subHeadingRow: {
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      dataSubRow: {
        textAlign: 'right',
        borderBottom: '1pt solid #A6A8AB',
        backgroundColor: '#f1f9ff',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    })
    return (
      <GeneratePDF
        width={'100%'}
        height={'440px'}
        size={[1670, 2000]}
        reportName={'Dispatch Report'}
        generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
        reportView={`Report View: ${detailedFilter?.Name}`}
        isSubHeading={true}
        title={'Dispatch Report'}
      >
        <View style={{ border: '1pt solid #A6A8AB' }}>
          <View style={styles.dataRow}>
            <Text style={styles.headerCell}>From Dispatch Date</Text>
            <Text style={styles.headerCell}>To Dispatch Date</Text>
            <Text style={styles.headerCell}>dispatch By Branch</Text>
            <Text style={styles.headerCell}>Destination City</Text>
            <Text style={styles.headerCell}>DestinationBranch</Text>
            <Text style={styles.headerCell}>Vehicle Number</Text>
            <Text style={styles.headerCell}>Payment Type</Text>
            <Text style={styles.headerCell}>Report Type</Text>
            <Text style={styles.headerCell}>Report View</Text>
            <Text style={styles.headerCell}>Report Option</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
            <Text style={styles.dataCell}>{headerData?.toDate}</Text>
            <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
            <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportView}</Text>
            <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
          </View>
        </View>
        <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
          <View style={styles.dataRow}>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>SN</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Vehicle No</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Driver Name & Contact</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatch To City <br/>Dispatch To Branch</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>NOP(Units)</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total LRs</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay + COD Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>OnAccount Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC+Self Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>DDDV Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>GST</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Valuation</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Other Charges</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Amount</Text>
          </View>
          <View style={{ border: '1pt solid #A6A8AB' }}>
            {tableData?.length < 1 ? (
              <>
                <View style={styles.dataRow}>
                  <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                    No results found. Please refine your search parameters and search again.
                  </Text>
                </View>
              </>
            ) : (
              <>
                {tableData?.map((item, index) => {
                  return (
                    <>
                      <View style={styles.dataSubRow}>
                        {Object.keys(item).length == 15 ? (
                          <>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '360px',textAlign: 'right',}}>
                              {item.Station}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.TotalUnits}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.TotalLRCount}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.TotalFreight}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.TopayFreight}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.PaidFreight}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.OnAccountFreight}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.FocAndSelfFreight}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.DDDVFreight}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.HamaliTotal}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.CartageTotal}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.GstTotal}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.ValuationTotal}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.OtherChargeTotal}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.TotalNetAmount}
                            </Text>
                          </>
                        ) : (
                          <>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {index + 1}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.BusNumber}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.DriverConductorContactNo}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.Station}
                              {item.ToBranchName}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.TotalUnits}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.TotalLRCount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.TotalFreight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.TopayFreight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.PaidFreight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.OnAccountFreight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.FocAndSelfFreight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.DDDVFreight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.HamaliTotal}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.CartageTotal}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.GstTotal}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.ValuationTotal}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.OtherChargeTotal}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.TotalNetAmount}
                            </Text>
                          </>
                        )}
                      </View>
                    </>
                  )
                })}
              </>
            )}
          </View>
        </View>
      </GeneratePDF>
    )
  }
//Detailed table LargePDF
export const VehicleWiseDispatchDetailedLargePdf = ({ paymentWiseTotal,fromDate, toDate, tableData, headerData, detailedFilter, intCompanyID }) => {
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const operatorHamaliHeader = isStaCompany(intCompanyID)
      ? getStaOperatorHamaliLabel(false)
      : 'Operator Hamali'
    const styles = StyleSheet.create({
      dataRow: {
        flexDirection: 'row',
        borderBottom: '1pt solid #A6A8AB',
      },
      dataCell: {
        flex: 1,
        fontSize: '12px',
        fontWeight: 500,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      headerCell: {
        backgroundColor: '#BFE1FF',
        flex: 1,
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      subHeadingRow: {
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      dataSubRow: {
        textAlign: 'right',
        borderBottom: '1pt solid #A6A8AB',
        backgroundColor: '#f1f9ff',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    })
    return (
      <GeneratePDF
        width={'100%'}
        height={'440px'}
        size={[2219, 2400]}
        reportName={'Dispatch Report'}
        generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
        reportView={`Report View: ${detailedFilter?.Name}`}
        isSubHeading={true}
        title={'Dispatch Report'}
      >
        <View style={{ border: '1pt solid #A6A8AB' }}>
          <View style={styles.dataRow}>
            <Text style={styles.headerCell}>From Dispatch Date</Text>
            <Text style={styles.headerCell}>To Dispatch Date</Text>
            <Text style={styles.headerCell}>dispatch By Branch</Text>
            <Text style={styles.headerCell}>Destination City</Text>
            <Text style={styles.headerCell}>DestinationBranch</Text>
            <Text style={styles.headerCell}>Vehicle Number</Text>
            <Text style={styles.headerCell}>Payment Type</Text>
            <Text style={styles.headerCell}>Report Type</Text>
            <Text style={styles.headerCell}>Report View</Text>
            <Text style={styles.headerCell}>Report Option</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
            <Text style={styles.dataCell}>{headerData?.toDate}</Text>
            <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
            <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportView}</Text>
            <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
          </View>
        </View>
        <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt'}}>
          <View style={styles.dataRow}>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>SN</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>LR No <br />Manual LR No</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Challan No <br />Bill No</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatch <br/>Date & Time</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Source City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Destination City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatch To City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatch To Branch</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Pickup City Branch</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Sender Details</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Receiver Details</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Item Type </Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Payment Type</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>QYT</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Document Charge</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage </Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>{operatorHamaliHeader}</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Freight GST</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage GST</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali+Op. <br />Hamali GST</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Valuation Charge </Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total</Text>
          </View>
          <View style={{ border: '1pt solid #A6A8AB' }}>
            {tableData?.length < 1 ? (
              <>
                <View style={styles.dataRow}>
                  <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                    No results found. Please refine your search parameters and search again.
                  </Text>
                </View>
              </>
            ) : (
              <>
                {tableData?.map((item, index) => {
                  return (
                    <>
                      <View style={styles.dataSubRow}>
                        {Object.keys(item).length == 7 ? (
                          <>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '360px',textAlign: 'left',backgroundColor:"rgb(241, 249, 255)"}}>
                            {`${item.OnlyLRNo} , ${item.VoucherNo} , ${item.DispatchDateTime}`}
                            </Text>
                          </>
                        ) :Object.keys(item).length ==17?(
                            <>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '1170px',textAlign: 'right',}}>
                              {item.OnlyLRNo}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.Quantity}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.Freight}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.DocumentCharges}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.CartageAmount}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.HamaliCharges}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.OperatorHamaliChg}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.ServiceTaxAmount}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.CartageTax}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.OptHamaliGST}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.Insurance}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.NetAmount}
                            </Text>
                          </>
                        ):(
                          <>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {index + 1}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.pdfLRNO}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.pdfVoucherNo}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                            { moment(item.DispatchDateTime).format('DD-MMM-YYYY hh:mm')}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.BookCity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.ToCity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.DispatchedToCityFilter}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.DispatchedToBranchFilter}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.PickupCityBranch}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.pdfSenderName}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.pdfRecName}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.ItemDetails}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.PaymentType}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.Quantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.Freight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.DocumentCharges}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.CartageAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.HamaliCharges}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.OperatorHamaliChg}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.ServiceTaxAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.CartageTax}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.OptHamaliGST}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.Insurance}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.NetAmount}
                            </Text>
                          </>
                        )}
                      </View>
                    </>
                  )
                })}
              </>
            )}
          </View>
        </View>
        <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt'}}>
          <View style={styles.dataRow}>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>PaymentType</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Item Type (Quantity)</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Doc Charge</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>{operatorHamaliHeader}</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Freight GST</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage GST</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali + Op.Hamali GST</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Valuation Charge</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total</Text>
          </View>
          <View style={{ border: '1pt solid #A6A8AB' }}>
            {paymentWiseTotal?.length < 1 ? (
              <>
                <View style={styles.dataRow}>
                  <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                    No results found. Please refine your search parameters and search again.
                  </Text>
                </View>
              </>
            ) : (
              <>
                {paymentWiseTotal?.map((item, index) => {
                  return (
                    <>
                      <View style={styles.dataSubRow}>
                      <>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.PaymentType}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.Quantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.Freight}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item.DocumentCharges}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.CartageAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.HamaliCharges}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.OperatorHamaliChg}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.ServiceTaxAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.CartageTax}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.OptHamaliGST}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.Insurance}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.NetAmount}
                            </Text>
                          </>
                      </View>
                    </>
                  )
                })}
              </>
            )}
          </View>
        </View>
      </GeneratePDF>
    )
  }
  export const WithVehicleAndChartDateDetailedLargePdf = ({ fromDate, toDate, groupDataSecond, headerData, detailedFilter }) => {
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const styles = StyleSheet.create({
      dataRow: {
        flexDirection: 'row',
        borderBottom: '1pt solid #A6A8AB',
      },
      dataCell: {
        flex: 1,
        fontSize: '12px',
        fontWeight: 500,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      headerCell: {
        backgroundColor: '#BFE1FF',
        flex: 1,
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      subHeadingRow: {
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      dataSubRow: {
        textAlign: 'right',
        borderBottom: '1pt solid #A6A8AB',
        backgroundColor: '#f1f9ff',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    })
    return (
      <GeneratePDF
        width={'100%'}
        height={'440px'}
        size={[2300, 2500]}
        reportName={'Dispatch Report'}
        generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
        reportView={`Report View: ${detailedFilter?.Name}`}
        isSubHeading={true}
        title={'Dispatch Report'}
      >
        <View style={{ border: '1pt solid #A6A8AB' }}>
          <View style={styles.dataRow}>
            <Text style={styles.headerCell}>From Dispatch Date</Text>
            <Text style={styles.headerCell}>To Dispatch Date</Text>
            <Text style={styles.headerCell}>dispatch By Branch</Text>
            <Text style={styles.headerCell}>Destination City</Text>
            <Text style={styles.headerCell}>DestinationBranch</Text>
            <Text style={styles.headerCell}>Vehicle Number</Text>
            <Text style={styles.headerCell}>Payment Type</Text>
            <Text style={styles.headerCell}>Report Type</Text>
            <Text style={styles.headerCell}>Report View</Text>
            <Text style={styles.headerCell}>Report Option</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
            <Text style={styles.dataCell}>{headerData?.toDate}</Text>
            <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
            <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportView}</Text>
            <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
          </View>
        </View>
        <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
          <View style={styles.dataRow}>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Vehicle No</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatch City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Receiving City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay+ <br />COD LRs</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid LRs</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>On Account LRs</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC+ <br/>Self LRs</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>DDDV LRs</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total LRs</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total UNITS</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay+ <br/>COD Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>On Account Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC+ <br/>Self Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>DDDV Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>TOTAL FREIGHT</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay+ <br/>COD GST+Other</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid <br/>GST+Other</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>On Account<br/> GST+Other</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC+ <br/>Self GST+Other</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>DDDV <br/>GST+Other</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>TOTAL GST+OTHER</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>TOTAL NET AMT</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Dispatch Date & Time</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Driver Name</Text>
          </View>
          <View style={{ border: '1pt solid #A6A8AB' }}>
            {groupDataSecond?.length < 1 ? (
              <>
                <View style={styles.dataRow}>
                  <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                    No results found. Please refine your search parameters and search again.
                  </Text>
                </View>
              </>
            ) : (
              <>
                {groupDataSecond?.map((item, index) => {
                  return (
                    <>
                      <View style={styles.dataSubRow}>
                        {Object.keys(item).length == 21 ? (
                          <>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '270px',
                                textAlign: 'right',
                              }}
                            >
                              {item.SummaryToCity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.topayCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.paidCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.onAccountCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.focCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.topaydddvCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.total}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalQuantity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.ToPayCodFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.paidFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.OnAccountFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.FocFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.DddvFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.ToPayCodGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.paidGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.OnAccountGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.FocGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.TopayDddvGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalNetAmount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              
                            </Text>
                          </>
                        ) : (
                            <>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'left',
                              }}
                            >
                              {item.VehicleNo}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'left',
                              }}
                            >
                              {item.SummaryFromCity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'left',
                              }}
                            >
                              {item.SummaryToCity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.topayCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.paidCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.onAccountCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.focCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.topaydddvCount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.total}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalQuantity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.ToPayCodFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.paidFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.OnAccountFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.FocFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.DddvFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalFreight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.ToPayCodGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.paidGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.OnAccountGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.FocGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.TopayDddvGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalGstOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.totalNetAmount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.DispatchDateTime}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                backgroundColor: 'white',
                                textAlign: 'right',
                              }}
                            >
                              {item.SummaryDriverConductorName}
                            </Text>
                          </>
                        )}
                      </View>
                    </>
                  )
                })}
              </>
            )}
          </View>
        </View>
      </GeneratePDF>
    )
  }
  export const WithPaymentTypeGroupLargePdf = ({ fromDate, toDate, tableData, headerData, detailedFilter }) => {
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const styles = StyleSheet.create({
      dataRow: {
        flexDirection: 'row',
        borderBottom: '1pt solid #A6A8AB',
      },
      dataCell: {
        flex: 1,
        fontSize: '12px',
        fontWeight: 500,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      headerCell: {
        backgroundColor: '#BFE1FF',
        flex: 1,
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      subHeadingRow: {
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      dataSubRow: {
        textAlign: 'right',
        borderBottom: '1pt solid #A6A8AB',
        backgroundColor: '#f1f9ff',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    })
    return (
      <GeneratePDF
        width={'100%'}
        height={'440px'}
        size={[1670, 2000]}
        reportName={'Dispatch Report'}
        generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
        reportView={`Report View: ${detailedFilter?.Name}`}
        isSubHeading={true}
        title={'Dispatch Report'}
      >
        <View style={{ border: '1pt solid #A6A8AB' }}>
          <View style={styles.dataRow}>
            <Text style={styles.headerCell}>From Dispatch Date</Text>
            <Text style={styles.headerCell}>To Dispatch Date</Text>
            <Text style={styles.headerCell}>dispatch By Branch</Text>
            <Text style={styles.headerCell}>Destination City</Text>
            <Text style={styles.headerCell}>DestinationBranch</Text>
            <Text style={styles.headerCell}>Vehicle Number</Text>
            <Text style={styles.headerCell}>Payment Type</Text>
            <Text style={styles.headerCell}>Report Type</Text>
            <Text style={styles.headerCell}>Report View</Text>
            <Text style={styles.headerCell}>Report Option</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
            <Text style={styles.dataCell}>{headerData?.toDate}</Text>
            <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
            <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportView}</Text>
            <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
          </View>
        </View>
        <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt' }}>
          <View style={styles.dataRow}>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>SN</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left',whiteSpace: 'pre-line'}}>{`LR No \n Challan No \n Manual LR No`}</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Vehicle No</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatch Date & Time</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Source City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Destination City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatched To City</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Dispatched To Branch</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Sender Details</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Receiver Details</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Item Details</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Units</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Freight</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Hamali</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Cartage</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Valuation</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Other Charges</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Net Amount</Text>
          </View>
          <View style={{ border: '1pt solid #A6A8AB' }}>
            {tableData?.length < 1 ? (
              <>
                <View style={styles.dataRow}>
                  <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                    No results found. Please refine your search parameters and search again.
                  </Text>
                </View>
              </>
            ) : (
              <>
                {tableData?.map((item, index) => {
                  return (
                    <>
                      <View style={styles.dataSubRow}>
                        {Object.keys(item).length == 7 ? (
                          <>
                            <Text
                              style={{
                                ...styles.dataCell,
                                backgroundColor:"rgb(241, 249, 255)",
                                minWidth: '360px',
                                textAlign: 'left',
                              }}
                            >
                              {item.OnlyLRNo}
                            </Text>
                          </>
                        ) :Object.keys(item).length == 12 ?(
                            <>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '990px',
                                textAlign: 'right',
                              }}
                            >
                              {item.OnlyLRNo}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.Quantity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.Freight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.HamaliCharges}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.CartageAmount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.Insurance}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.AllOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                              }}
                            >
                              {item.NetAmount}
                            </Text>
                          </>
                        ):(
                          <>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {index}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                             {item.OnlyLRNo} <br />{item.VoucherNo} <br /> {item.ManualLR}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.VehicleNoFilter}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.DispatchDateTime}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.BookCity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.ToCity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.DispatchedToCityFilter}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.DispatchedToBranchFilter}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.SenderName}<br /> {item.SenderMobileNo}<br /> {item.SenderGSTN} <br /> {item.SenderEmailID}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.RecName} <br /> {item.RecMobileNo}<br /> {item.ReceiverGSTN} <br />{item.ReceiverEmailID}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'left',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.ItemDetails}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.Quantity}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.Freight}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.HamaliCharges}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.CartageAmount}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.Insurance}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.AllOther}
                            </Text>
                            <Text
                              style={{
                                ...styles.dataCell,
  
                                backgroundColor: tableHeaderColor?.isTotalColor,
                                minWidth: '90px',
                                textAlign: 'right',
                                backgroundColor: 'white',
                              }}
                            >
                              {item.NetAmount}
                            </Text>
                          </>
                        )}
                      </View>
                    </>
                  )
                })}
              </>
            )}
          </View>
        </View>
      </GeneratePDF>
    )
  }
  export const ShowOnlyToPayAmountDetailedLargePdf = ({paymentWiseVehicleData,paymentSummary,fromDate, toDate, tableData, headerData, detailedFilter }) => {
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const styles = StyleSheet.create({
      dataRow: {
        flexDirection: 'row',
        borderBottom: '1pt solid #A6A8AB',
      },
      dataCell: {
        flex: 1,
        fontSize: '12px',
        fontWeight: 500,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      headerCell: {
        backgroundColor: '#BFE1FF',
        flex: 1,
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      subHeadingRow: {
        fontSize: '12px',
        fontWeight: 600,
        paddingVertical: 8,
        paddingHorizontal: 5,
        color: '#444',
      },
      dataSubRow: {
        textAlign: 'right',
        borderBottom: '1pt solid #A6A8AB',
        backgroundColor: '#f1f9ff',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    })
    return (
      <GeneratePDF
        width={'100%'}
        height={'440px'}
        size={[1940, 2200]}
        reportName={'Dispatch Report'}
        generateDate={`Report Time: ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`}
        reportView={`Report View: ${detailedFilter?.Name}`}
        isSubHeading={true}
        title={'Dispatch Report'}
      >
        <View style={{ border: '1pt solid #A6A8AB' }}>
          <View style={styles.dataRow}>
            <Text style={styles.headerCell}>From Dispatch Date</Text>
            <Text style={styles.headerCell}>To Dispatch Date</Text>
            <Text style={styles.headerCell}>dispatch By Branch</Text>
            <Text style={styles.headerCell}>Destination City</Text>
            <Text style={styles.headerCell}>DestinationBranch</Text>
            <Text style={styles.headerCell}>Vehicle Number</Text>
            <Text style={styles.headerCell}>Payment Type</Text>
            <Text style={styles.headerCell}>Report Type</Text>
            <Text style={styles.headerCell}>Report View</Text>
            <Text style={styles.headerCell}>Report Option</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={styles.dataCell}>{headerData?.fromDate}</Text>
            <Text style={styles.dataCell}>{headerData?.toDate}</Text>
            <Text style={styles.dataCell}>{headerData?.dispatchByBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationCity}</Text>
            <Text style={styles.dataCell}>{headerData?.destinationBranch}</Text>
            <Text style={styles.dataCell}>{headerData?.vehicleNumber}</Text>
            <Text style={styles.dataCell}>{headerData?.paymentType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportType}</Text>
            <Text style={styles.dataCell}>{headerData?.reportView}</Text>
            <Text style={styles.dataCell}>{headerData?.reportOption}</Text>
          </View>
        </View>
        <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt'}}>
          <View style={styles.dataRow}>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>LR No</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Sender Name</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Sender GSTN</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Receiver Name</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Receiver GSTIN</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>No of Parcels</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Goods Description</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Payment Type</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Amount</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Remarks</Text>
          </View>
          <View style={{ border: '1pt solid #A6A8AB' }}>
            {paymentSummary?.length < 1 ? (
              <>
                <View style={styles.dataRow}>
                  <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                    No results found. Please refine your search parameters and search again.
                  </Text>
                </View>
              </>
            ) : (
              <>
                {paymentSummary?.map((item, index) => {
                  return (
                    <>
                      <View style={styles.dataSubRow}>
                        {Object.keys(item).length == 1 ? (
                          <>
                            <Text  style={{...styles.dataCell,backgroundColor:"rgb(241, 249, 255)",minWidth: '360px',textAlign: 'left',}}>
                            {item.LRNO}
                            </Text>
                          </>
                        ) :Object.keys(item).length ==4?(
                            <>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '850px',textAlign: 'right',}}>
                              {item.LRNO}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {item.Quantity}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {/* {item.Quantity} */}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                              {/* {item.Quantity} */}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                            {item.NetAmount}
                            </Text>
                            <Text  style={{...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',textAlign: 'right',}}>
                            {/* {item.NetAmount} */}
                            </Text>
                          </>
                        ):(
                          <>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.OnlyLRNo}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.SenderName}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.SenderGSTN}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.RecName}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.ReceiverGSTN}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.Quantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.ItemDetails}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.PaymentType}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.NetAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.Remarks}
                            </Text>
                          </>
                        )}
                      </View>
                    </>
                  )
                })}
              </>
            )}
          </View>
        </View>
        <View style={{ border: '1pt solid #A6A8AB', marginTop: '20pt'}}>
          <View style={styles.dataRow}>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'left' }}>Vehicle No</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Paid Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>ToPay Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>FOC Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>COD Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>COD Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>OnAct Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>OnAct Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>PaidManual Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>PaidManual Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>TopayManual Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>TopayManual Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>SelfBooking Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>SelfBooking Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>OnActManual Unit</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>OnActManual Amt</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Units</Text>
            <Text style={{ ...styles.headerCell, minWidth: '90px', textAlign: 'right' }}>Total Amount</Text>
          </View>
          <View style={{ border: '1pt solid #A6A8AB' }}>
            {paymentWiseVehicleData?.length < 1 ? (
              <>
                <View style={styles.dataRow}>
                  <Text style={{ ...styles.dataCell, width: '100%', textAlign: 'center' }}>
                    No results found. Please refine your search parameters and search again.
                  </Text>
                </View>
              </>
            ) : (
              <>
                {paymentWiseVehicleData?.map((item, index) => {
                  return (
                    <>
                      <View style={styles.dataSubRow}>
                      <>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'left',}}>
                              {item.vehicleNo}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.paidQuantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.paidAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item.toPayQuantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.toPayAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.fOCQuantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.fOCAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.cODQuantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.cODAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.onAccountQuantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                              {item.onAccountAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item['paid(Manual)Quantity']}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item['paid(Manual)Amount']}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item['toPay(Manual)Quantity']}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item['toPay(Manual)Amount']}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item.selfQuantity}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item.selfAmount}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item['onAccount(Manual)Quantity']}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item['onAccount(Manual)Amount']}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item.totalUnits}
                            </Text>
                            <Text style={{ ...styles.dataCell,backgroundColor: tableHeaderColor?.isTotalColor,minWidth: '90px',backgroundColor: 'white',textAlign: 'right',}}>
                            {item.totalAmount}
                            </Text>
                          </>
                      </View>
                    </>
                  )
                })}
              </>
            )}
          </View>
        </View>
      </GeneratePDF>
    )
  }
  